import { CrossConnectCost, PortCost } from '../../../../../../types/pricedQuote';
import { CablingType } from '../../../../../../types/store';

export const setInstallCost = (isCopper: boolean, crossConnectCost: CrossConnectCost | null): number => {
  const adminFee = crossConnectCost?.admin_fee ?? 0;
  const installCost = isCopper ? crossConnectCost?.copper?.install ?? 0 : crossConnectCost?.fibre?.install ?? 0;
  return adminFee + installCost;
};

export const setAnnualCost = (isCopper: boolean, crossConnectCost: CrossConnectCost | null) => {
  return isCopper ? crossConnectCost?.copper?.annual ?? 0 : crossConnectCost?.fibre?.annual ?? 0;
};

export const setCablingType = (isCopper: boolean, hasCabling: boolean | null): CablingType | null => {
  if (!hasCabling) return null;
  return isCopper ? CablingType.Copper : CablingType.Fibre;
};

/**
 * Check if campus cross connect is available for a specific end (A or B)
 */
export const hasCampusCrossConnect = (end: 'A' | 'B', additionalServices: string[] | null | undefined): boolean => {
  if (!additionalServices || !Array.isArray(additionalServices)) {
    return false;
  }
  return additionalServices.some((service) =>
    service.includes(`Campus Cross Connect - End ${end}`)
  );
};

/**
 * Extract campus cross connect location from the additional services string
 * Example: "Campus Cross Connect - End B - via Slough (LD5) 1 SL1 4AX" -> "Slough (LD5) 1 SL1 4AX"
 */
export const extractCampusCrossConnectLocation = (
  end: 'A' | 'B',
  additionalServices: string[] | null | undefined
): string | null => {
  if (!additionalServices || !Array.isArray(additionalServices)) {
    return null;
  }

  const service = additionalServices.find((s) =>
    s.includes(`Campus Cross Connect - End ${end}`)
  );

  if (!service) {
    return null;
  }

  // Extract everything after "via "
  const viaIndex = service.indexOf('via ');
  if (viaIndex !== -1) {
    return service.substring(viaIndex + 4).trim();
  }

  return null;
};

/**
 * Get campus cross connect cost for a specific end
 */
export const getCampusCrossConnectValue = (
  end: 'A' | 'B',
  type: 'Cost' | 'Price',
  additionalPrices: (PortCost[] | null | undefined)
): { install: number; annual: number } | null => {
  if (!additionalPrices || !Array.isArray(additionalPrices)) {
    return null;
  }

  // Find the cost entry (usually the first one with "Cost" in description for the given end)
  const costEntry = additionalPrices.find((price) =>
    price.description?.includes(`Campus Cross Connect - End ${end} ${type}`)
  );

  if (!costEntry) {
    return null;
  }

  return {
    install: costEntry.install,
    annual: costEntry.annual,
  };
};
